import React from "react";
import { Button, Modal } from "react-bootstrap";

const DisclaimerModal = ({ show, onClose }) => {
  return (
    <Modal show={show} animation={false}>
      <Modal.Header className="bg-dark ">
        <Modal.Title className="text-light">Disclaimer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mt-4 ml-2 mr-2 mb-4 font-weight-normal">
          This website was created by a group of students from IIT(ISM) Dhanbad
          working independently to collect and display pan-India Covid resources
          and information in a more structured manner.
          <br />
          <br />
          Although we try our best to keep verifying the links regularly, some
          information or links present here may not be working or accurate.
          Please contact us or report such resources, if you come across one.
        </p>
      </Modal.Body>

      <Modal.Footer className="bg-light">
        <Button variant="primary" onClick={onClose}>
          Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DisclaimerModal;
